import React, { useState } from 'react';
import './Card.css';

const COLOR_IMG = { WHITE: '/cards/White.png', BLUE: '/cards/Blue.png', GREEN: '/cards/Green.png', RED: '/cards/Red.png', BLACK: '/cards/Black.png' };

/* ============ Cost gem pips — reusable ============ */
export function GemPip({ color, count }) {
  return <span className={`gem-pip ${color.toLowerCase()}`}>{count}</span>;
}

/* ============ Cost row — renders all cost entries ============ */
export function CostRow({ cost, className = '' }) {
  return (
    <div className={className}>
      {Object.entries(cost).map(([color, count]) =>
        count > 0 ? <GemPip key={color} color={color} count={count} /> : null
      )}
    </div>
  );
}

/* ============ Labeled cost row with color name ============ */
function LabeledCostRow({ cost }) {
  const entries = Object.entries(cost).filter(([, c]) => c > 0);
  return (
    <div className="dev-card__cost-row">
      {entries.map(([color, count]) => (
        <span key={color} className={`dev-card__cost-pip ${color.toLowerCase()}`}>
          {count}
        </span>
      ))}
    </div>
  );
}

/* ============ Bonus gem circle ============ */
export function BonusGem({ color, size = 20 }) {
  return (
    <span
      className={`dev-card__bonus-gem ${color.toLowerCase()}`}
      style={{ width: size, height: size }}
    />
  );
}

/* ============ Main table Card ============ */
export function Card({ card, canBuy, isMyTurn, onBuy, onReserve }) {
  const [hovered, setHovered] = useState(false);
  const colorCls = card.color.toLowerCase();

  return (
    <div
      className={`dev-card ${colorCls}${canBuy ? ' can-buy' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onContextMenu={(e) => { e.preventDefault(); if (isMyTurn) onReserve(); }}
      style={{ backgroundImage: `url(${COLOR_IMG[card.color]})` }}
    >
      {/* Top overlay: level + points */}
      <div className="dev-card__top">
        <span className="dev-card__points">{card.points > 0 ? card.points : ''}</span>
      </div>

      {/* Bottom overlay: cost gems */}
      <div className="dev-card__bottom">
        <LabeledCostRow cost={card.cost} />
      </div>

      {/* Hover actions */}
      {hovered && isMyTurn && (
        <div className="dev-card__actions">
          {canBuy && (
            <button className="dev-card__btn dev-card__btn--buy"
              onClick={(e) => { e.stopPropagation(); onBuy(); }}>买</button>
          )}
          <button className="dev-card__btn dev-card__btn--reserve"
            onClick={(e) => { e.stopPropagation(); onReserve(); }}>预定</button>
        </div>
      )}
    </div>
  );
}

/* ============ MiniCard (stacked in player panel) ============ */
export function MiniCard({ card }) {
  return (
    <div
      className={`mini-dev-card ${card.color.toLowerCase()}`}
      style={{ backgroundImage: `url(${COLOR_IMG[card.color]})` }}
    >
      <div className="mini-dev-card__info">
        <span className="mini-dev-card__points">{card.points || ''}</span>
        <BonusGem color={card.color} size={12} />
      </div>
    </div>
  );
}

/* ============ CardTooltip (hover preview) ============ */
export function CardTooltip({ card }) {
  if (!card) return null;
  return (
    <div className="card-tooltip">
      <div className="card-tooltip__header">
        <span className="card-tooltip__pts">{card.points || 0}</span>
        <BonusGem color={card.color} size={16} />
      </div>
      <CostRow cost={card.cost} className="card-tooltip__cost" />
    </div>
  );
}

/* ============ ReservedCard (player reserved section) ============ */
export function ReservedCard({ card, canBuy, isMyTurn, onBuy }) {
  const colorCls = card.color.toLowerCase();
  return (
    <div
      className={`reserved-dev-card ${colorCls}`}
      style={{ backgroundImage: `url(${COLOR_IMG[card.color]})` }}
    >
      <div className="reserved-dev-card__info">
        <div className="reserved-dev-card__header">
          <span className="reserved-dev-card__level">Lv{card.tier}</span>
          <span className="reserved-dev-card__pts">{card.points || 0}</span>
        </div>
        <CostRow cost={card.cost} className="reserved-dev-card__cost" />
      </div>
      {isMyTurn && canBuy && (
        <button
          type="button"
          className="reserved-dev-card__buy-btn"
          aria-label="购买预约牌"
          onClick={() => onBuy(card)}
        >
          买
        </button>
      )}
    </div>
  );
}
